export default __webpack_public_path__ + "static/media/link.5f9222dc.png";